import {useEffect, useRef} from 'react'
import styles from './index.module.scss'
interface HeaderProps {
  logo?: string
  slots?: any
}
export const Header = (props: HeaderProps) => {
  const refVueSlot = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const vue = props.slots?.$mount()
    if (refVueSlot.current) {
      refVueSlot.current.appendChild(vue.$el)
    }
    return () => {
      refVueSlot.current?.removeChild(vue.$el)
      vue && vue.$destroy()
    }
  }, [])

  return (
    <div className={styles.headerContainer}>
      <div className={styles.leftArea}>{props.logo && <img src={props.logo} className={styles.logo} />}</div>
      <div className={styles.rightArea} ref={refVueSlot}></div>
    </div>
  )
}
export default Header
